import chroma from "chroma-js";

export type PrimaryPalette = Readonly<{
  default: string;
  1: string; // light
  2: string; // lighter
  // dark equivalents
  "1-dark": string;  // dark
  "2-dark": string;  // darker
}>;

export const derivePalette = (colorA: string): PrimaryPalette => ({
  default: colorA,
  1: chroma(colorA).tint(0.7).hex(),
  2: chroma(colorA).tint(0.95).hex(),
  "1-dark": chroma(colorA).shade(0.9).hex(),
  "2-dark": chroma(colorA).shade(0.95).hex(),
});
